import React, { useState, useEffect } from 'react';
import './ContactForm.css';
import { FaArrowRight, FaEnvelope } from 'react-icons/fa';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const { name, email, message } = formData;
    if (name && email && message) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    const { name, email, message } = formData;

    try {
      const response = await fetch(
        'https://qz76jvc6d7.execute-api.us-east-1.amazonaws.com/prod/email',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, email, message }),
        }
      );

      if (!response.ok) {
        throw new Error('Error sending email');
      }

      await response.json();
      setStatus('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Error:', error);
      setStatus('Failed to send. Please email us directly.');
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-content-wrapper">
        {/* Left Side: Information */}
        <div className="contact-info">
          <h1>Get in Touch</h1>
          <p>
            Have a question about the <strong>halwaa</strong> app or a business inquiry for <strong>findhalal</strong>?
            We are here to help. Reach out to our team and we will get back to you shortly.
          </p>

          <div className="contact-meta">
            <a href="mailto:support@findhalal.us" className="contact-meta-item email-link">
              <FaEnvelope />
              <span>support@findhalal.us</span>
            </a>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="contact-form-card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Jane Doe"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="jane@company.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">How can we help?</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your inquiry..."
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn" disabled={isButtonDisabled}>
              Send Message <FaArrowRight />
            </button>

            {status && <p className="form-status">{status}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;